// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"6d58a5cdef6f6181ea51","655":"8b0e7cb7456ce5917cbe"}[chunkId] + ".js";
};